const pdfjsLib = require('pdfjs-dist');

if (typeof window !== 'undefined') {
  pdfjsLib.GlobalWorkerOptions.workerSrc = '/static/pdf.worker.min.mjs';
}

module.exports = pdfjsLib;
